export const tableHeader = [
  {
    name: '№',
    key: 'number',
  },
  {
    name: 'ФИО',
    key: 'fio',
  },
  {
    name: 'Организация',
    key: 'organization',
  },
  {
    name: 'Участие',
    key: 'status',
  },
  {
    name: 'Направление',
    key: 'direction',
  },
  {
    name: 'Доклад',
    key: 'name',
  },
  {
    name: 'Презентация',
    key: 'presentation',
  },
  {
    name: 'Комментарий',
    key: 'comment',
  },
  {
    name: '',
    key: 'action',
  },
];

// export const testData = [
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
//   {
//     fio: ["Тоноян Артур Арменович", "Иванов Иван Иванович"],
//     organization.prisma:
//       "Санкт-Петербургский государственный электротехнический университет «ЛЭТИ»",
//     participation: "Аспирант",
//     direction:
//       "7. Проблемы математического моделирования и управления в области медицины",
//     report:
//       "Проект по созданию распределенной сети полигонов для отработки сценариев применения гетерогенных групп транспортных средств с электрическим приводом в сложных климатических и ландшафтных условиях, проблемы и перспективы реализации на примере САО РАН",
//   },
// ];

// export const directionList = [
//   "7. Проблемы математического моделирования и управления в области медицины",
//   "8. Проблемы математического моделирования и управления в области медицины",
//   "9. Проблемы математического моделирования и управления в области медицины",
//   "10. Проблемы математического моделирования и управления в области медицины",
//   "11. Проблемы математического моделирования и управления в области медицины",
//   "12. Проблемы математического моделирования и управления в области медицины",
// ];
